import Vue from 'vue';
import '@mdi/font/css/materialdesignicons.css';
// import Vuetify from 'vuetify/lib/framework';
import Vuetify from 'vuetify'
import ro from 'vuetify/es5/locale/ro';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi',
    },
    // table footers, date pickers and empty states in Romanian
    lang: {
        locales: { ro },
        current: 'ro',
    },
    theme: {
        themes: {
            light: {
                primary: '#2D8659',
                secondary: '#0E2A21',
                accent: '#7FD1A3',
                success: '#2D8659',
                info: '#245F9E',
                warning: '#C27F16',
                error: '#B3362F',
            },
        },
    },
});
